import Http from './http'

export const getPoints = async ({ studentId }) => {
  const data = await Http.get(`/students/${studentId}/points`)
  return data.data
}

export const getRankingGlobal = async ({ studentId }) => {
  const data = await Http.get(`/students/${studentId}/ranking/global`)
  return data.data
}

export const getRankingByUnit = async ({ studentId }) => {
  const data = await Http.get(`/students/${studentId}/ranking/unit`)
  return data.data
}

export const getRankingByClass = async ({ studentId }) => {
  const data = await Http.get(`/students/${studentId}/ranking/class`)
  return data.data
}

export const getLevel = async ({ studentId }) => {
  const data = await Http.get(`/students/${studentId}/level`)
  return data.data
}

export const getQuarentineProgress = async ({ studentId }) => {
  const data = await Http.get(`/students/${studentId}/quarentineProgress`)
  return data.data
}
